import makeStyles from '@mui/styles/makeStyles';

const bp = 1550

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    maxHeight: '300px',
    objectFit: 'cover',
    borderRadius: '8px',
    cursor: 'pointer'
  },

  maxHeight: {
    height: '100%',
    objectFit: 'cover',
    width: '10vw',

    [theme.breakpoints.down(bp)]: {
      width: '10vw'
    },

    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },

  opaque: {
    filter: 'brightness(0.2)',
    opacity: '0.7'
  },

  text: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    zIndex: '1',
    width: '100%',
    height: '100%'
  }
}))

export default useStyles
